import React, { Dispatch, SetStateAction, useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Select, SpinnerOverlay, SubmissionButtons } from '@components/common';

import useQueryValuesForCreate from '@hooks/configurationDataModelManagement/useQueryOranValuesForCreate';

import { isEmpty } from '@utils/common';

import {
	EOranConfigurationDataFieldNames,
	IOranConfigurationDataFormValues,
} from '@interfaces/cmModule/configurationData';
import { TUseFormReturnCustomError } from '@interfaces/errors/useFormErrors';

import { EValidationMode } from '@enums/validationMode';

import { regExpWithoutSpace } from '@constants/regExp';
import {
	configurationOranDataFormLabels,
} from '@components/routes/CmModule/ConfigurationDataModelManagement/constants';

import { schema } from './schema';

import styles from '../ImportConfigurationDataModelForm/ImportConfigurationDataModelForm.module.scss';

interface IImportOranConfigurationDataModelForm {
	onClose: () => void;
	onSubmitHandler: (values: IOranConfigurationDataFormValues) => void;
	setIsDirty: Dispatch<SetStateAction<boolean>>;
	setIsConfirmModalNeeded: Dispatch<SetStateAction<boolean>>;
}

const defaultValues = {
	[EOranConfigurationDataFieldNames.NAME]: null,
};

const ImportOranConfigurationDataModelForm = ({
	onClose,
	onSubmitHandler,
	setIsDirty,
	setIsConfirmModalNeeded,
}: IImportOranConfigurationDataModelForm) => {
	const { presetNames, isLoadingPresetNames } = useQueryValuesForCreate();

	const {
		handleSubmit,
		formState: { errors, isDirty },
		control,
		reset,
	}: TUseFormReturnCustomError<IOranConfigurationDataFormValues> = useForm<IOranConfigurationDataFormValues>({
		mode: EValidationMode.all,
		resolver: yupResolver(schema),
		defaultValues,
	});

	const onSubmit = (values: IOranConfigurationDataFormValues) => {
		onSubmitHandler(values);

		reset(defaultValues);
	};

	const validateNewOption = useCallback((value: string) => {
		return !value.match(regExpWithoutSpace);
	}, []);

	useEffect(() => {
		setIsDirty(isDirty);

		if (isDirty) {
			setIsConfirmModalNeeded(true);
		}
	}, [isDirty, setIsConfirmModalNeeded, setIsDirty]);

	return (
		<div>
			{isLoadingPresetNames && <SpinnerOverlay />}
			<div className={styles.collectionName}>
				<Select
					control={control}
					errorMessage={errors[EOranConfigurationDataFieldNames.NAME]?.message
						|| errors[EOranConfigurationDataFieldNames.NAME]?.value?.message}
					isCreatable
					isError={!!errors[EOranConfigurationDataFieldNames.NAME]
						|| !!errors[EOranConfigurationDataFieldNames.NAME]?.value}
					label={configurationOranDataFormLabels[EOranConfigurationDataFieldNames.NAME]}
					name={EOranConfigurationDataFieldNames.NAME}
					options={presetNames}
					placeholder='Select YANG model collection name'
					required
					validateNewOption={validateNewOption}
				/>
			</div>
			<div className={styles.submitButtons}>
				<SubmissionButtons
					disabledPositive={!isEmpty(errors)}
					negativeHandler={onClose}
					positiveHandler={handleSubmit(onSubmit)}
					positiveLabel='Next'
				/>
			</div>
		</div>
	);
};

export default ImportOranConfigurationDataModelForm;
